import { PAGE_TRANSITION_MARK } from './markPageTransition';
import { getEntriesByName, measure } from './performance';

const isPerformanceSupported = (pageTransEntry) => pageTransEntry !== undefined;

const wasPageTransition = (pageTransitions) => pageTransitions.length > 0;

export const timeDifferenceBetween = (
  startMark,
  endMark,
  measurementName,
  performance,
) => {
  try {
    measure(measurementName, startMark, endMark, performance);
  } catch (err) {
    // do nothing
  }
  const entries = getEntriesByName(measurementName, performance) || [];
  return entries.length > 0 ? entries[0].duration : undefined;
};

export const calculateTimeElapsedSinceLastTransitionOrMarkTime = (
  markName,
  performance,
) => {
  const pageTransitionEntry = getEntriesByName(
    PAGE_TRANSITION_MARK,
    performance,
  );

  if (!isPerformanceSupported(pageTransitionEntry)) {
    return undefined;
  }

  if (!wasPageTransition(pageTransitionEntry)) {
    const entries = getEntriesByName(markName, performance) || [];
    return entries.length > 0 ? entries[0].startTime : undefined;
  }

  const measurementName = `${markName}_measurement`;
  return timeDifferenceBetween(
    PAGE_TRANSITION_MARK,
    markName,
    measurementName,
    performance,
  );
};
